module.exports = __webpack_public_path__ + "img/mypage_header_point.0d778ba.svg";